module.exports = __webpack_public_path__ + "media/LandingPageAssets/DailyDiaryFeature-094016c0.png";